module.exports = __webpack_public_path__ + "static/Aeonik-Regular-3db4c95924c643b42a29d8233fb77e96.woff";